import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { BatchAttendanceCsvUploadComponent } from "./batch-attendance-csv-upload/batch-attendance-csv-upload.component";
import { BatchAttendanceImportCompareRequest } from "../shared/batch-attendance-import-compare-request";
import { DataService_batchattendance } from "../shared/data.service";

@Component({
	selector: "caass-batch-attendance-csv",
	templateUrl: "./batch-attendance-csv.component.html",
	styleUrls: ["./batch-attendance-csv.component.css"],
})
export class BatchAttendanceCsvComponent implements OnInit {
	constructor(private dialogService: DialogService, private dataService: DataService_batchattendance) {}

	ngOnInit(): void {}

	//////////////////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////////////////

	lstImportCompare: any = [];

	TableLoading: boolean = false;
	Processing: boolean = false;
	errorMessage: string = "";

	//////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////////////////

	onUpload() {
		this.errorMessage = "";

		var ref = this.dialogService.open(BatchAttendanceCsvUploadComponent, {
			header: "Upload CSV",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != 0) {
				this.CheckData(response);
			}
		});
	}

	CheckData(parms: BatchAttendanceImportCompareRequest) {
		this.TableLoading = true;
		var result = this.dataService.BatchAttendanceImportCompare(parms);
		result.subscribe(
			(response) => {
				console.log(response);
				this.lstImportCompare = response;

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	onFinish() {}

	//////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.TableLoading == true || this.Processing == true;
	}

	//////////////////////////////////////////////////////////////////////////////
}
